<div class="flex min-h-[192px] flex-1 flex-col gap-4">
  <snt-attachments
    [labelIdle]="
      '<div class=\'flex flex-col gap-2 items-center justify-center pt-8\'><i class=\'fa-light fa-cloud-upload fa-2xl\' style=\'line-height: unset; font-size: 2em;\'></i><span>Trascina e rilascia gli allegati o <span class=\'filepond--label-action\'> clicca qui </span> per selezionarli</span></div>'
        | transloco
    "
    [attachments]="attachments"
    (linked)="onLinked($event)"
    (unLinked)="onUnlinked($event)"
    (removed)="onRemoved($event)"
  ></snt-attachments>
</div>
